<template>
  <div class="box">
    <div v-for="(item, index) of labels.value" :key="index" :style="{'background-color': colors[index % 3], left: item.startLeft, width: item.width}" class="label" :title="item.label">{{ item.label }}</div>
  </div>
</template>

<script>
import {allChart, sleep} from './common.js'

export default {
  inject: ['labelInfo', 'labels'],

  props: {
    perf_second_data: Object,
    chartKey: String,
  },

  data() {
    return {
      colors: ['rgb(145, 124, 190)', 'rgb(94, 190, 181)', 'rgb(237, 131, 92)'],
      //labels: [],
    }
  },

  methods: {
  }
}
</script>

<style scoped>
.box {
  position: absolute;
  display: flex;
  top: 35px;
  left: 0;
  /* right: 30px; */
}

.label {
  position: absolute;
  text-align: center;
  height: 28px;
  line-height: 28px;
  color: #fff;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>